import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InitialMoneyCountController from "./InitialMoneyCountController";
import CustomBtn from "components/fragments/CustomBtn";
import { authHandler } from "../../redux/handlers";
import { getCurrentDateTime } from "utils/getCurrentDateTime";

export default function POSStartSellingModal({ modalPosSettingStart, startValueObj, selectedDevice, onStartSelling }) {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const [userData, setUserData] = useState(null);
  const [rowValues, setRowValues] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isResetMoneyController, setIsResetMoneyController] = useState(false);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await dispatch(authHandler.getUserBusinessProfile(businessSlug));
        if (response) {
          setUserData(response);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };
    if (modalPosSettingStart.modalPosSettingStartOpen) {
      fetchUserProfile();
      setIsInitialized(false);
    }
  }, [modalPosSettingStart.modalPosSettingStartOpen, dispatch, businessSlug]);

  const handleOnSubmit = () => {
    if (!rowValues) {
      console.error("No row values available");
      return;
    }

    const cashCounts = {
      cash_1000: rowValues[0]?.displayCount?.currentValue || 0,
      cash_500: rowValues[1]?.displayCount?.currentValue || 0,
      cash_100: rowValues[2]?.displayCount?.currentValue || 0,
      cash_50: rowValues[3]?.displayCount?.currentValue || 0,
      cash_20: rowValues[4]?.displayCount?.currentValue || 0,
      cash_10: rowValues[5]?.displayCount?.currentValue || 0,
      cash_5: rowValues[6]?.displayCount?.currentValue || 0,
      cash_1: rowValues[7]?.displayCount?.currentValue || 0,
    };

    const callbackData = {
      posSellingId: selectedDevice?.rawData?.id || null,
      branchPosId: selectedDevice?.id || null,
      ...cashCounts,
    };

    // ปิด modal เริ่มต้นขาย
    modalPosSettingStart.setModalPosSettingStartOpen(false);

    // ส่งข้อมูลกลับไปที่ parent component
    if (onStartSelling) {
      onStartSelling(callbackData);
    }
  };

  const handleRowValuesUpdate = (updatedRowValues) => {
    setRowValues(updatedRowValues);
  };

  const getFullName = () => {
    if (!userData) return "กำลังโหลด...";
    return `${userData.first_name || ""} ${userData.last_name || ""}`;
  };

  const getPosName = () => {
    if (!selectedDevice) return "POS";
    return selectedDevice.posInfo?.posName || "POS";
  };

  const handleInitialButtonClick = () => {
    setIsInitialized(true);
  };

  const handleCloseModal = () => {
    modalPosSettingStart.setModalPosSettingStartOpen(false);
  };

  return (
    <Modal
      aria-labelledby="pos-setting-start-modal"
      aria-describedby="modal-for-starting-pos-session"
      open={modalPosSettingStart.modalPosSettingStartOpen}
      onClose={handleCloseModal}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Fade in={modalPosSettingStart.modalPosSettingStartOpen}>
        <div className="bg-white w-[min(58.98vw,604px)] px-[min(2.44vw,25px)] pt-[min(2.44vw,25px)] pb-[min(1.46vw,15px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-20 text-[var(--color-black-2)]">
          <div className="relative">
            <button onClick={handleCloseModal} className="absolute top-0 right-0 aspect-square w-[min(3.90vw,39.97px)] rounded-full bg-[#F5F5F5] flex justify-center items-center">
              <img className="aspect-square object-contain w-[min(0.98vw,10px)]" src="/img/icons/icon-close.svg" alt="Close" />
            </button>
          </div>

          <div className="font-[500] leading-[2]">เริ่มต้นขาย</div>

          <div>
            <InitialMoneyCountController
              startValueObj={startValueObj}
              info={{
                cashierName: getPosName(),
                staffName: getFullName(),
                calTxt: "ตั้งต้น",
                startTime: getCurrentDateTime(),
              }}
              isResetObj={{
                isReset: isResetMoneyController,
                setIsReset: setIsResetMoneyController,
              }}
              onRowValuesUpdate={handleRowValuesUpdate}
              onInitialized={handleInitialButtonClick}
            />

            <div className="bg-[#EDEDED] w-full h-[min(0.10vw,1px)] mt-[min(1.96vw,20.12px)]"></div>

            <div className="flex justify-center">
              <CustomBtn
                onClick={handleOnSubmit}
                className={`leading-[0.8] min-w-[min(24.71vw,253px)] text-white font-[400] text-16 min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] mt-[min(1.56vw,16px)] mb-[min(0.98vw,10px)] ${
                  isInitialized ? "btn-main-active" : "opacity-50 cursor-not-allowed bg-gray-400"
                }`}
                btntxt={"เริ่มต้นขาย"}
                disabled={!isInitialized}
              />
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
